
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/category/[slug]",
      function () {
        return require("private-next-pages/articles/category/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/category/[slug]"])
      });
    }
  